import { Check, AlertTriangle, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

const STATUS_ICON = {
  pass: { Icon: Check, cls: "text-blue-600" }, warn: { Icon: AlertTriangle, cls: "text-amber-500" },
  fail: { Icon: XCircle, cls: "text-red-500" },
};
const LEVEL_STYLE = { Strong: "bg-blue-600 text-white", "Getting there": "bg-amber-100 text-amber-800", "Needs work": "bg-slate-200 text-slate-700" };

const ReadinessCheck = ({ check, prefix }) => {
  const { Icon, cls } = STATUS_ICON[check.status] || STATUS_ICON.warn;
  return (
    <li className="flex items-start gap-3 px-4 py-3" data-testid={`${prefix}-check-${check.id}`}>
      <Icon className={cn("mt-0.5 h-4.5 w-4.5 shrink-0", cls)} />
      <span>
        <span className="block text-sm font-semibold text-slate-900">{check.label}</span>
        <span className="block text-sm text-slate-500">{check.detail}</span>
      </span>
    </li>
  );
};

const KeywordResult = ({ alignment, prefix }) => {
  if (!alignment?.provided) return null;
  return (
    <div className="mt-4 rounded-xl border border-border bg-blue-50 p-4" data-testid={`${prefix}-keywords`}>
      <p className="text-sm font-semibold text-slate-900">Keyword alignment · {alignment.coverage_pct}%</p>
      {alignment.missing.length > 0 && (
        <p className="mt-2 text-sm text-slate-600">Consider adding: {alignment.missing.slice(0, 10).map((keyword) => (
          <span key={keyword} className="mr-1.5 inline-block rounded-full border border-border bg-white px-2 py-0.5 text-xs text-slate-700">{keyword}</span>
        ))}</p>
      )}
    </div>
  );
};

export const ReadinessResult = ({ readiness, prefix = "readiness" }) => {
  if (!readiness) return null;
  return (
    <div className="mt-5" data-testid={`${prefix}-result`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h4 className="font-heading text-lg font-bold text-slate-900">Resume Readiness Check</h4>
        <span className={cn("rounded-full px-3 py-1 text-xs font-semibold", LEVEL_STYLE[readiness.readiness_level])} data-testid={`${prefix}-level`}>
          {readiness.readiness_level}
        </span>
      </div>
      <p className="mt-1 text-sm text-slate-500" data-testid={`${prefix}-counts`}>{readiness.checks_passed} of {readiness.checks_total} checks passed</p>
      <ul className="mt-4 divide-y divide-border rounded-xl border border-border bg-white">
        {readiness.checks.map((check) => <ReadinessCheck key={check.id} check={check} prefix={prefix} />)}
      </ul>
      <KeywordResult alignment={readiness.keyword_alignment} prefix={prefix} />
      <p className="mt-4 text-xs leading-relaxed text-slate-400" data-testid={`${prefix}-disclaimer`}>{readiness.disclaimer}</p>
    </div>
  );
};